export default __webpack_public_path__ + "static/media/camera.cdaf8f37.svg";